import React, { useEffect, useState } from 'react';
import { reduce, debounce } from 'lodash';
import {
  BYO_DRIVE_TYPE_CHANGE,
  addCustomEvent,
  removeCustomEvent,
} from '../utils/customMessage';

const AlignCardsContent = ({ children, numberOfCards }) => {
  const getMaxHeight = () =>
    reduce(
      refs,
      (max, ref) => {
        const height = ref?.current?.offsetHeight;
        return height > max ? height : max;
      },
      0
    );

  const initRefs = () =>
    Array.from({ length: numberOfCards }, () => React.createRef());
  const [maxHeight, setMaxHeight] = useState(0);
  const [refs] = useState(initRefs());

  const getRefByIndex = (index) => {
    return refs[index];
  };

  const calHeight = debounce(() => {
    // Reset the height so we can calculate the maximum height
    setMaxHeight(0);

    setMaxHeight(getMaxHeight());
  }, 400);

  useEffect(() => {
    calHeight();

    window.addEventListener('resize', calHeight);
    addCustomEvent(BYO_DRIVE_TYPE_CHANGE, calHeight);

    return () => {
      window.removeEventListener('resize', calHeight);
      removeCustomEvent(BYO_DRIVE_TYPE_CHANGE, calHeight);
    };
  }, []);

  return (
    <>
      {children({
        maxHeight,
        getRefByIndex,
      })}
    </>
  );
};

export default AlignCardsContent;
